import React from 'react';
import Icon from '../../../components/AppIcon';

const ComplianceMonitor = ({ complianceData }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'excellent': return 'text-success';
      case 'good': return 'text-accent';
      case 'warning': return 'text-warning';
      case 'critical': return 'text-error';
      default: return 'text-muted-foreground';
    }
  };

  const getStatusBg = (status) => {
    switch (status) {
      case 'excellent': return 'bg-success/10';
      case 'good': return 'bg-accent/10';
      case 'warning': return 'bg-warning/10';
      case 'critical': return 'bg-error/10';
      default: return 'bg-muted/10';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'excellent': return 'CheckCircle';
      case 'good': return 'CheckCircle';
      case 'warning': return 'AlertTriangle';
      case 'critical': return 'XCircle';
      default: return 'Info';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 elevation-2">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground">Compliance Monitoring</h3>
        <div className="flex items-center space-x-2">
          <div className="w-2 h-2 bg-success rounded-full animate-pulse" />
          <span className="text-sm text-muted-foreground">Live Monitoring</span>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        {complianceData?.metrics?.map((metric) => (
          <div key={metric?.id} className={`p-4 rounded-lg ${getStatusBg(metric?.status)}`}>
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center space-x-2">
                <Icon name={getStatusIcon(metric?.status)} size={16} className={getStatusColor(metric?.status)} />
                <span className="text-sm font-medium text-foreground">{metric?.name}</span>
              </div>
              <span className={`text-lg font-bold ${getStatusColor(metric?.status)}`}>
                {metric?.value}
              </span>
            </div>
            <p className="text-xs text-muted-foreground">{metric?.description}</p>
          </div>
        ))}
      </div>
      <div className="space-y-4">
        <h4 className="text-sm font-medium text-foreground">Recent Compliance Events</h4>
        <div className="space-y-3 max-h-64 overflow-y-auto">
          {complianceData?.events?.map((event) => (
            <div key={event?.id} className="flex items-start space-x-3 p-3 bg-muted/30 rounded-lg">
              <Icon 
                name={getStatusIcon(event?.severity)} 
                size={16} 
                className={`mt-0.5 ${getStatusColor(event?.severity)}`} 
              />
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground">{event?.title}</p>
                <p className="text-xs text-muted-foreground mt-1">{event?.description}</p>
                <div className="flex items-center space-x-4 mt-2">
                  <span className="text-xs text-muted-foreground">{event?.timestamp}</span>
                  {event?.action && (
                    <button className="text-xs text-primary hover:text-primary/80 font-medium">
                      {event?.action}
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="mt-6 p-4 bg-muted/30 rounded-lg">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <Icon name="Shield" size={16} className="text-primary" />
            <span className="text-sm font-medium text-foreground">Overall Compliance Score</span>
          </div>
          <div className="text-right">
            <span className="text-2xl font-bold text-success">{complianceData?.overallScore}%</span>
            <p className="text-xs text-muted-foreground">Excellent</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComplianceMonitor;